module.exports = __webpack_public_path__ + "img/MotorolaG20.4d33dc1f.png";